var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-instance-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between align-items-start" }, [
        _c(
          "div",
          { staticClass: "nk-block-head-content admin-instance-page__intro" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "admin-instance-page__back admin-instance-page__back--pill",
                attrs: {
                  to: "/currency",
                  title: _vm.trans("currency.currency"),
                  "aria-label": _vm.trans("currency.currency"),
                },
              },
              [
                _c("admin-icon", {
                  attrs: { name: "chevron-left", "aria-hidden": "true" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "admin-instance-page__intro-text" }, [
              _c("div", { staticClass: "admin-instance-list__title-row" }, [
                _c("h3", { staticClass: "nk-block-title page-title mb-0" }, [
                  _vm._v(_vm._s(_vm.trans("currency.edit_currency"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nk-block-des text-soft" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.trans("currency.module_info_description"))),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card admin-plan-form-card" }, [
      _c(
        "div",
        { staticClass: "card-body admin-plan-form-card__body" },
        [_c("currency-form", { attrs: { id: _vm.id } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }